import InvoiceThemeService from "./invoiceThemeService"

/**
 * All size units are in mm.
 * Only settings which are different from the default values need to be defined.
 * See invoiceThemeService for default settigns
 * Set colors as rgb or rgba
 */

export const defaultSettings = InvoiceThemeService.bobbeeDefaultTheme()/*InvoiceThemeService.mergeWithDefaultSettings({
    useAdvancedStyling: true,
    page: {
        horizontalMargin: 10,
        verticalMargin: 10,
        fontSize: 11,
        useBackgroundImage: false,
    },
    headerContentBox: {
        iconBox: {
            logoSizeMultiplier: 0.5,
        },

        invoiceTypeBox: {
            useInvoiceNumber: false,
            style: {
                // backgroundColor:"#355269ff",
                // borderColor: "#355269",
                // boxHeight: 17,
                // padding: 2,
                // color: "#ffffff",
            }
        }
    },
    style:{
        displayHeaderDivider: false,
        displayFooterDivider: false,
    },
})*/

export const v2Default = InvoiceThemeService.v2DefaultTheme()

export const originalTheme = InvoiceThemeService.originalTheme()


export const theme1 = InvoiceThemeService.mergeWithDefaultSettings({
    "useAdvancedStyling": true,
    "page": {
        "horizontalMargin": 10,
        "verticalMargin": 10,
        "useBackgroundImage": true,
        "selectedDefaultBackgroundKey": "invoice-assets/background_1.png"
    },
    "headerContentBox": {
        "iconBox": {
            "logoSizeMultiplier": 0.5,
        },
    },
    vatTableBox: {
        header:{
            backgroundColor:"#17253AFF",
        }
    },
    "totalsBox": {
        "style": {
            "rightMargin": 0,
        }
    },
    "paginationBox": {
        "style": {
            "color": "#FFFFFFFF"
        }
    },
    "footerContentBox": {
        "style": {
            "color": "#FFFFFFFF",
            "boxHeight": 0,
            "boxWidth": 0,
            "topMargin": "",
            "padding": 0
        }
    },
    "style": {
        "displayHeaderDivider": false,
        "displayFooterDivider": false
    },
    "tables": {
        "header": {
            "backgroundColor": "#17253AFF",
            "columns": [
                {checked: false, optional: true, text: 'Référence', column: 'Référence', value: 'reference', align: 'left', width: 20, boldText: false, type: null},
                {checked: true, optional: false, text: 'Produit', column: 'Produit', value: 'product', align: 'left', width: 45, boldText: false, type: null},
                {checked: true, optional: false, text: 'Quantité', column: 'Quantité', value: 'quantity', align: 'center', width: 12, boldText: false, type: "number"},
                {checked: false, optional: true, text: 'Type', column: 'Type (stock)', value: 'type', align: 'center', width: 10, boldText: false, type: null},
                {checked: true, optional: false, text: 'Prix unitaire', column: 'Prix unitaire', value: 'unitPrice', align: 'center', width: 15, boldText: false, type: 'amount'},
                {checked: true, optional: false, text: 'Taux TVA', column: 'Taux TVA', value: 'vatRate', align: 'center', width: 15, boldText: false, type: 'percent'},
                {checked: false, optional: true, text: 'TVA', column: 'TVA', value: 'vatAmount', align: 'center', width: 5, boldText: false, type: 'amount'},
                {checked: true, optional: false, text: 'Remise', column: 'Remise', value: 'discount', align: 'center', width: 15, boldText: false, type: "percent"},
                {checked: true, optional: true, text: 'Montant HT', column: 'Montant HT', value: 'netAmount', align: 'center', width: 20, boldText: true, type: 'amount'},
                {checked: false, optional: true, text: 'Montant TTC', column: 'Montant TTC', value: 'grossAmount', align: 'right', width: 20, boldText: true, type: 'amount'},
            ]
        },
    }
})

export const theme2 = InvoiceThemeService.mergeWithDefaultSettings(
    {
        "useAdvancedStyling": true,
        "page": {
            "horizontalMargin": 15,
            "verticalMargin": 10,
            "fontFamily": "Tahoma",
            "fontSize": 10,
            "useBackgroundImage": true,
            "backgroundOpacity": 50,
            "selectedDefaultBackgroundKey": "invoice-assets/background_4.png"
        },
        "headerContentBox": {
            "iconBox": {
                "logoSizeMultiplier": 0.5,
            }
        },
        "titleBox": {
            "style": {
                "topMargin": 7,
                "bottomMargin": 7,
                "padding": 0
            }
        },
        "paymentDetailsBox": {
            "style": {
                "topMargin": 7
            }
        },
        vatTableBox: {
            header:{
                backgroundColor:"#DF505097",
            },
            rows:{
                border: true,
                borderColor: "#AAAAAAFF",
                backgroundColor:"#FFFFFFC3"
            },
        },
        "footerContentBox": {
            "style": {
                "backgroundColor": "#00000000",
                "borderRadius": "1",
                "boxHeight": 0,
                "boxWidth": 0,
                "rightMargin": ""
            }
        },
        "style": {
            "displayFooterDivider": false
        },
        "position": {
            "emitter": {
                "sameLevelAsReceiver": true
            },
        },
        "tables": {
            "header": {
                "backgroundColor": "#DF505097",
                "columns": [
                    {checked: false, optional: true, text: 'Référence', column: 'Référence', value: 'reference', align: 'left', width: 20, boldText: false, type: null},
                    {checked: true, optional: false, text: 'Produit', column: 'Produit', value: 'product', align: 'left', width: 45, boldText: false, type: null},
                    {checked: true, optional: false, text: 'Qté', column: 'Quantité', value: 'quantity', align: 'center', width: 10, boldText: false, type: "number"},
                    {checked: false, optional: true, text: 'Type', column: 'Type (stock)', value: 'type', align: 'center', width: 10, boldText: false, type: null},
                    {checked: true, optional: false, text: 'Prix unitaire', column: 'Prix unitaire', value: 'unitPrice', align: 'center', width: 15, boldText: false, type: 'amount'},
                    {checked: true, optional: false, text: 'TVA', column: 'Taux TVA', value: 'vatRate', align: 'center', width: 10, boldText: false, type: 'percent'},
                    {checked: false, optional: true, text: 'TVA', column: 'TVA', value: 'vatAmount', align: 'center', width: 5, boldText: false, type: 'amount'},
                    {checked: true, optional: false, text: 'Remise', column: 'Remise', value: 'discount', align: 'center', width: 15, boldText: false, type: "percent"},
                    {checked: true, optional: true, text: 'Montant HT', column: 'Montant HT', value: 'netAmount', align: 'right', width: 15, boldText: true, type: 'amount'},
                    {checked: false, optional: true, text: 'Montant TTC', column: 'Montant TTC', value: 'grossAmount', align: 'right', width: 20, boldText: true, type: 'amount'},
                ]
            },
            "rows": {
                "borderColor": "#AAAAAAFF",
                "backgroundColor": "#FFFFFFC3",
            },
        },
    }
)

export const theme3 = InvoiceThemeService.mergeWithDefaultSettings({
    "useAdvancedStyling": true,
    "page": {
        "horizontalMargin": 15,
        "verticalMargin": 10,
        "fontFamily": "Tahoma",
        "fontSize": 10,
        "useBackgroundImage": true,
        "selectedDefaultBackgroundKey": "invoice-assets/background_2.png"
    },
    "headerContentBox": {
        "iconBox": {
            "logoSizeMultiplier": 0.5,
        },
        "invoiceTypeBox": {
            "showInvoiceType": false
        }
    },
    "titleBox": {
        "style": {
            "bottomMargin": "3"
        }
    },
    "mainTableBox": {
        "rows": {
            "mode": "alternating"
        }
    },
    vatTableBox: {
        header:{
            backgroundColor:"#355269FF",
        },
        rows:{
            border: true,
            borderColor: "#AAAAAAFF",
            backgroundColor:"#D6E2F1FF",
            mode: "alternating"
        },
    },
    "footerContentBox": {
        "style": {
            "backgroundColor": "#FFFFFFBF",
            "borderRadius": "1",
            "padding": 3
        }
    },
    "style": {
        "displayHeaderDivider": false,
        "displayFooterDivider": false
    },
    "tables": {
        "header": {
            "backgroundColor": "#355269FF",
            "columns": [
                {checked: false, optional: true, text: 'Référence', column: 'Référence', value: 'reference', align: 'left', width: 20, boldText: false, type: null},
                {checked: true, optional: false, text: 'Produit', column: 'Produit', value: 'product', align: 'left', width: 45, boldText: false, type: null},
                {checked: true, optional: false, text: 'Qté', column: 'Quantité', value: 'quantity', align: 'center', width: 10, boldText: false, type: "number"},
                {checked: false, optional: true, text: 'Type', column: 'Type (stock)', value: 'type', align: 'center', width: 10, boldText: false, type: null},
                {checked: true, optional: false, text: 'Prix unitaire', column: 'Prix unitaire', value: 'unitPrice', align: 'center', width: 15, boldText: false, type: 'amount'},
                {checked: true, optional: false, text: 'TVA', column: 'Taux TVA', value: 'vatRate', align: 'center', width: 10, boldText: false, type: 'percent'},
                {checked: false, optional: true, text: 'TVA', column: 'TVA', value: 'vatAmount', align: 'center', width: 5, boldText: false, type: 'amount'},
                {checked: true, optional: false, text: 'Remise', column: 'Remise', value: 'discount', align: 'center', width: 15, boldText: false, type: "percent"},
                {checked: true, optional: true, text: 'Montant HT', column: 'Montant HT', value: 'netAmount', align: 'right', width: 15, boldText: true, type: 'amount'},
                {checked: false, optional: true, text: 'Montant TTC', column: 'Montant TTC', value: 'grossAmount', align: 'right', width: 20, boldText: true, type: 'amount'}
            ]
        },
        "rows": {
            "borderColor": "#AAAAAAFF",
            "backgroundColor": "#D6E2F1FF"
        }
    }
})

export const theme4 = InvoiceThemeService.mergeWithDefaultSettings({
    useAdvancedStyling: true,
    page: {
        horizontalMargin: 10,
        verticalMargin: 10,
        fontSize: 11,

        useBackgroundImage: true,
        selectedDefaultBackgroundKey: "invoice-assets/background_2.png",  // When a default background is selected, this is set to the fileKey of the default background
        backgroundSize: "cover", // cover, contain, auto
        backgroundRepeat: "repeat", // repeat, no-repeat, repeat-x, repeat-y
        backgroundPosition: "top", // top, center, bottom
    },
    headerContentBox: {
        iconBox: {
            logoSizeMultiplier: 0.5,
        },

        invoiceTypeBox: {
            useInvoiceNumber: true,
            style: {
                // backgroundColor:"#355269ff",
                // borderColor: "#355269",
                boxHeight: 17,
                padding: 2,
                // color: "#ffffff",
            }
        }
    },
    emitter: {
        style: {
            padding: 3,
            border: true,
            borderColor: "#333333FF"
        }
    },
    receiver: {
        style: {
            padding: 3,
            border: true,
            borderColor: "#333333FF"
        }
    },
    mainTableBox: {
        header:{
            border: true,
            backgroundColor:"#355269FF"
        },

        rows:{
            border: true,
            borderColor: "#333333FF",
            backgroundColor:"#EFEFEFFF",
            secondaryBackgroundColor: "#FFFFFFFF",
            mode: "alternating",  // "default", "simple", "alternating"
        },
    },
    vatTableBox: {
        header:{
            backgroundColor:"#355269",
        },
        rows:{
            border: true,
            borderColor: "#333333FF",
            backgroundColor:"#EFEFEFFF",
            secondaryBackgroundColor: "#FFFFFFFF",
            mode: "alternating",  // "default", "simple", "alternating"
        },
    },
    titleBox: {
        style: {
            topMargin: 5,
            bottomMargin: 5,
        }
    },

    style:{
        displayHeaderDivider: false,
        displayFooterDivider: false,
    },

    tables: {
        header:{
            backgroundColor:"#355269",
        },
        rows:{
            border: true,
            borderColor: "#333333FF",
            backgroundColor:"#EFEFEFFF",
        },
    },
    summary: {
        showVATSummary: true,  // TODO update after replacement
        vatTable: {
            columns: JSON.parse(JSON.stringify(InvoiceThemeService.getAllVATTableColumns()))
        },
    },
    position:{
        emitter:{
            sameLevelAsReceiver: true,
        },
    }
})

export const availableThemes = [
    {
        name: "D'origine",
        settings: {
            ...originalTheme,
            name: "D'origine"
        },
        thumbnailUri: require("./assets/defaultBackgrounds/theme_d_origine.png"),
    },
    {
        name: "Par défaut",
        settings: {
            ...v2Default,
            name: "Par défaut"
        },
        thumbnailUri: require("./assets/defaultBackgrounds/theme_defaultv2.png"),
    },
    // {
    //     name: "bobbee",
    //     settings: {
    //         ...defaultSettings,
    //         name: "bobbee"
    //     },
    //     thumbnailUri: require("./assets/defaultBackgrounds/theme_default.png"),
    // },
    {
        name: "Thème 1",
        settings: {
            ...theme1,
            name: "Thème 1"
        },
        thumbnailUri: require("./assets/defaultBackgrounds/theme_1.png"),
    },
    {
        name: "Thème 2",
        settings: {
            ...theme2,
            name: "Thème 2"
        },
        thumbnailUri: require("./assets/defaultBackgrounds/theme_2.png"),
    },
    {
        name: "Thème 3",
        settings: {
            ...theme3,
            name: "Thème 3"
        },
        thumbnailUri: require("./assets/defaultBackgrounds/theme_3.png"),
    },
]
